<template>
  <v-container>
    <div class="header-border pb-3 mb-3">
      <v-row
        no-gutters
        align="center"
      >
        <h1 class="book-list-header">
          {{ $t('search.results', { searchTerm: $route.params.searchTerm }) }}
        </h1>
        <v-spacer />
      </v-row>
    </div>
    <div>
      <ApolloQuery
        :query="(gql) => getBooksBySearch"
        :variables="{
          searchText: $route.params.searchTerm,
          page: 1,
        }"
        :update="(data) => data?.localBooks?.collection || []"
      >
        <template #default="{ result: { error, data }, isLoading, query }">
          <book-display
            :data="data"
            :is-loading="!!isLoading"
            :error="error"
            :query="query"
            :loading-items="loadingItemsCount"
          />
          <v-container v-if="(!data || data.length === 0) && !isLoading">
            <v-row justify="center">
              <v-col
                class="col-12 col-sm-8 pa-16"
                justify="center"
                align="center"
              >
                <book-list-icon :size="72" />
                <h1>{{ $t('search.noResults', { searchTerm: $route.params.searchTerm }) }}</h1>
                <v-btn
                  tile
                  block
                  color="primary"
                  class="mt-4"
                  :to="{ name: 'home' }"
                >
                  {{ $t('common.returnToShop') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </ApolloQuery>
    </div>
  </v-container>
</template>

<script>
import BookListIcon from "@/components/icons/BookListIcon";
import LocalBookFragments from "@/graphql/LocalBookFragments";
import BookDisplay from "@/components/BookDisplay";
import gql from "graphql-tag";
import { buildSocialMeta, PRODUCTION_DOMAIN } from '@/helpers/socialMetaHelper';
import { buildLocalizedPageUrl } from '@/helpers/localeUrlHelper';

const LOADING_ITEM_COUNT = 12;

export default {
  name: "SearchResults",
  metaInfo() {
    const title = this.$t('routes.searchResults') + ': ' + (this.$route.params.searchTerm || '')
    const description = this.$t('seo.searchDescription', { searchTerm: this.$route.params.searchTerm || '' })
    return {
      title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        ...buildSocialMeta(title, description, `${PRODUCTION_DOMAIN}${buildLocalizedPageUrl(this.$route?.path || '/', this.$route?.query?.lang, this.$store?.getters?.languageCode)}`),
      ],
    }
  },
  components: {
    BookListIcon,
    BookDisplay,
  },
  data() {
    return {
      loadingItemsCount: LOADING_ITEM_COUNT,
    };
  },
  computed: {
    getBooksBySearch() {
      return gql`
        query searchProducts($page: Int!, $searchText: String) {
          localBooks(page: $page, simplesearch: $searchText) {
            collection {
              ...LocalBookCore
            }
          }
        }
        ${LocalBookFragments.localBookCoreFragment}
      `
    },
  },
};
</script>
